import Apollo from '@adoratorio/apollo';
import engine from './engine';

const apollo = {
  ref: null,

  init(DOMEelement) {
    this.ref = new Apollo({
      cursor: DOMEelement,
      easing: {
        mode: Apollo.EASING.CUBIC,
        duration: 400,
      },
      props: [],
      targets: [],
      aion: engine,
    });
    engine.start();
  },
};

export default apollo;
